import { Table, Tag, Tooltip } from 'antd';
import React, { useEffect } from 'react'
import { useMutation } from 'react-query';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import HeadingBack from '../../../component/HeadingBack';
import SvgIcon from '../../../const/SvgIcon';
import { UserServices } from '../../../redux/Services';
import { usePermission, useRights } from '../../../hooks/usePermission';
import { UserId } from "../../../utils/";
const UserRoles = () => {
    const permission = usePermission("Users Management", "List");
    const rights = useRights("Users Management");
    // Editable = the role is manageable (own org / super admin) and the user has Edit
    const canEditRole = (item) => !!item?.CanEdit && rights.Edit;
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const roleList = useSelector(state => state.user.roleList || []);
    const totalRole = useSelector(state => state.user.totalRole || "");
    const { mutate: getRolesList, isLoading } = useMutation((data) => dispatch(UserServices.fetchRolesApi(data,user)));
    const user={
        UserId:UserId
    }
    useEffect(() => {
        getRolesList({});
        return () => { }
    }, [])
    const columns = [
        {
            title: 'S.No.',
            dataIndex: 'sno',
            key: 'sno',
            className:'table_first_col',
            render: (value, item, index) => ++index
        },
        {
            title: 'Role Name',
            dataIndex: 'Role',
            key: 'Role',
            className: 'text-capitalize',
        },
        {
            title: 'Organization',
            dataIndex: 'OrganizationId',
            key: 'OrganizationId',
            // Shared roles are usable by every organization; only super admin edits them
            render: (value, item) => item?.IsSuperAdmin
                ? <Tag color="gold">All organizations</Tag>
                : item?.IsShared
                ? <Tag color="blue">Shared</Tag>
                : <span>{item?.OrganizationName || value}</span>
        },
        {
            title: 'Actions',
            dataIndex: 'action',
            key: 'action',
            className: 'table_action_col',
            render: (value, item, index) => {
                return (
                    <>
                        {canEditRole(item) && (
                            <Tooltip title="Edit">
                                <span className='cursor-pointer' onClick={() => navigate(`/role/edit/${item?.RoleId}`)}><SvgIcon.Edit className="scale-icon edit-icon" /></span>
                            </Tooltip>
                        )}
                        <Tooltip title={canEditRole(item) ? "Edit Permissions" : "View Permissions"}>
                            <Link className='ml-10' to={`/role/user-permission/${item?.RoleId}`}><SvgIcon.PermissionIcon className="scale-icon edit-icon" /></Link>
                        </Tooltip>
                    </>
                )
            }
        },
    ];
    return (
        <div>
            <div className='flex'>
                <div>
                    <HeadingBack title={"Roles"} subHeading={`Total ${totalRole || 0}`} />
                </div>
                <div className='flex1 flex justify-content-end align-items-center'>
                    {rights.Add && (
                        <Tooltip title="Add"><span className='jop_btn' onClick={() => navigate("/role/add")}>Add<SvgIcon.Add width={40} height={40} className="cursor-pointer" /></span></Tooltip>
                    )}
                </div>
            </div>
            <div className='tableResponsive mt-10'>
                <Table
                    rowKey='RoleId'
                    className={isLoading ? 'table antd_table no_data_found_hide' : 'table antd_table'}
                    bordered
                    columns={columns}
                    dataSource={Array.isArray(roleList) && roleList?.length > 0 ? roleList : []}
                    pagination={false}
                />
            </div>
        </div>
    )
}

export default UserRoles
